import EditorActionButton from './EditorActionButton.component';

export default EditorActionButton;
